import {
  Box,
  Modal,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";

import { ModalBaseStyles, ModalHeader } from "../../Common/styles/modal";
import { NoDataContainer, StyledTableCell } from "../../Common/styles/table";

export const getColorByStatus = (status: string) => {
  if (status === "completed") {
    return "#70AE71";
  } else if (status === "inprogress") {
    return "#F49D4C";
  } else if (status === "not_started") {
    return "#9CA3AF";
  } else {
    return "#9CA3AF";
  }
};

type Props = {
  showModal: boolean;
  closeModal: () => void;
  data: any;
};

const statusMap: any = {
  not_started: "Not started",
  completed: "Completed",
  inprogress: "In progress",
};

const ProgressDetailModal = ({ showModal, closeModal, data }: Props) => {
  return (
    <Modal open={showModal} onClose={closeModal}>
      <Box sx={{ ...ModalBaseStyles, width: "60vw", minHeight: "20vh" }}>
        <ModalHeader title={"Progress"} onCloseClick={closeModal} />
        {data?.length > 0 && (
          <Box
            sx={{
              maxHeight: "calc(100vh - 295px)",
              overflow: "auto",
              mb: 2,
            }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Visit Name</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data?.map((row: any) => (
                  <TableRow key={row?.id}>
                    <StyledTableCell>{row?.phaseName}</StyledTableCell>
                    <StyledTableCell>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontWeight: "regular",
                          color: getColorByStatus(row?.status),
                        }}
                      >
                        {statusMap[row?.status]}
                      </Typography>
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
        {data.length === 0 && (
          <NoDataContainer>
            <Typography variant="body1" color="gray">
              No Data
            </Typography>
          </NoDataContainer>
        )}
      </Box>
    </Modal>
  );
};

export default ProgressDetailModal;
